export default __webpack_public_path__ + "static/media/Endurance.725820ef.jpg";